
import { useEffect, useState } from "react";
import { Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { OpenSendDocumentMessageAsPubSub, OpenSendDocumentMessageAsPubSubPayload } from "@utils/pubsubs/PubSub";
import LoadingScreen from "@components/content/LoadingScreen";
import DashboardLinksSection from "@components/content/DashboardLinksSection";
import AgregarDocumentoIcon from '@assets/icons-png/agregar-documento.png';

type SendDocumentMessageAsOffCanvasProps = {
} & DefaultOffCanvasProps

const SendDocumentMessageAsOffCanvas = (props: SendDocumentMessageAsOffCanvasProps) => {
    const { btnColor = "primary", className } = props;
    const [isOpen, setOpen] = useState(false);
    const [invoiceAttachmentId, setInvoiceAttachmentId] = useState<string>();

    useEffect(() => {
        const unsubscribe = OpenSendDocumentMessageAsPubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenSendDocumentMessageAsPubSubPayload) => {
        const { openOffCanvas = false, invoiceAttachmentId: attachmentId } = payload;
        setOpen(openOffCanvas);
        setInvoiceAttachmentId(attachmentId);
    }

    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >

                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Seleccione un tipo de documento
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <DashboardLinksSection
                            sm="4"
                            xs="6"
                            lg="3"
                            xl="3"
                            title="Cuentas Por Pagar"
                            links={[
                                {
                                    icon: AgregarDocumentoIcon,
                                    iconAlt: "Icono Validar Factura Electronica",
                                    title: "Validar Factura Electronica",
                                    onClick: () => {
                                        onCanvasClosed()
                                    },
                                    url: `/user/provider-invoices/validateEDocument/${invoiceAttachmentId}`,
                                    target: "_blank"
                                },
                                {
                                    icon: AgregarDocumentoIcon,
                                    iconAlt: "Icono Validar Nota Credito Electronica",
                                    title: "Validar Nota Credito Electronica",
                                    onClick: () => {
                                        onCanvasClosed()
                                    },
                                    url: `/user/provider-Invoices/notes/validateENote/${invoiceAttachmentId}`,
                                    target: "_blank"
                                },
                            ]}
                        />

                        <DashboardLinksSection
                            title="Registro de Gastos"
                            sm="4"
                            xs="6"
                            lg="3"
                            xl="3"
                            links={[
                                {
                                    icon: AgregarDocumentoIcon,
                                    iconAlt: "Icono Validar Factura Electronica",
                                    title: "Validar Factura Electronica",
                                    onClick: () => {
                                        onCanvasClosed()
                                    },
                                    url: `/user/expenses/validateEDocument/${invoiceAttachmentId}`,
                                    target: "_blank"
                                },
                                {
                                    icon: AgregarDocumentoIcon,
                                    iconAlt: "Icono Validar Nota Credito Electronica",
                                    title: "Validar Nota Credito Electronica",
                                    onClick: () => {
                                        onCanvasClosed()
                                    },
                                    url: `/user/expenses/validateEDocumentNote/${invoiceAttachmentId}`,
                                    target: "_blank"
                                },
                            ]}
                        />

                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
        </>
    );
}
export default SendDocumentMessageAsOffCanvas;
